module.exports = __webpack_public_path__ + "media/errors/500-error-1d1ab553.png";